import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';

@Component({
    standalone: false,
    selector: 'account-created-message-component',
    templateUrl: 'accountCreated.message.component.html'
})

export class AccountCreatedMessageComponent {

    constructor(
      public dialogRef: MatDialogRef<AccountCreatedMessageComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public route: ActivatedRoute,
      public alertService: AlertService,
      public authenticationService: AuthenticationService) {
    }

    onLogOff(): void{
        this.dialogRef.close();
        this.authenticationService.logout();
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
